import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  BulkRecipient,
  DisplayContactField,
} from '@rivethealth/data/bulk-composer';
import { BulkEstimateContactType } from '@rivethealth/data/contact';
import { BulkChip, SearchItem } from '@rivethealth/data/ui-search-item';

@Component({
  selector: 'bulk-chip-input',
  styleUrls: ['./bulk-chip-input.component.scss'],
  templateUrl: './bulk-chip-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkChipInputComponent {
  constructor() {}
  @Input() chips: BulkRecipient[] = [];
  @Input() chipType: BulkEstimateContactType;

  @Output() openPatientEdit = new EventEmitter<number>();
  @Output() openSelectContactField = new EventEmitter<DisplayContactField[]>();
  @Output() removeChip = new EventEmitter<BulkChip>();
  @Output() rvChange = new EventEmitter<SearchItem[]>();

  remove(index: number) {
    this.removeChip.emit(this.chips[index]);
    this.rvChange.emit(this.chips.filter((_, i) => i != index));
  }

  add(chips: BulkChip[]) {
    this.rvChange.emit([...this.chips, ...chips]);
  }

  sendOpenSelectContactField(chip: BulkRecipient) {
    this.openSelectContactField.emit(
      chip.contactFields.length > 0 ? chip.contactFields : [],
    );
  }
}
